import { Tab } from "./sample/Tab";
import { SubdomainStep } from "./Subdomain";

export const Settings = () => {
  return (
    <Tab>
      <SubdomainStep />
    </Tab>
  );
};
